export const removeBackSlash = (str) => {
    if (str.startsWith('/')) {
      return str.substring(1);
    }
    return str;
  };
